import { defineComponent as _defineComponent } from 'vue'
import BaseButton from 'JS/components/BaseButton.vue';
import Icon from 'JS/components/Icon.vue';
import SalesFlyerLightboxViewDesktop from './SalesFlyerLightboxViewDesktop.vue';
import SalesFlyerLightboxViewMobile from './SalesFlyerLightboxViewMobile.vue';
import { computed, onMounted, ref } from 'vue';
import { SalesFlyerResource } from '../../types';
import { useBreakpoints } from 'JS/composables/breakpoint';
import { usePreventBodyScroll } from 'JS/composables/prevent-body-scroll';


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerLightbox',
  props: {
    salesFlyer: null,
    initialPageIndex: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close');
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	salesFlyer: SalesFlyerResource,
	initialPageIndex?: number | null;
}





const dialog = ref<HTMLDialogElement>();
onMounted(() => {
	dialog.value.showModal();
});

const currentPageIndex = ref(props.initialPageIndex ?? 0);
const currentPage = computed(() => currentPageIndex.value + 1);
const totalPages = computed(() => props.salesFlyer.pages.length);

usePreventBodyScroll();

const { isDesktop } = useBreakpoints();
const LightboxView = computed(() => isDesktop.value ? SalesFlyerLightboxViewDesktop : SalesFlyerLightboxViewMobile);


return { __sfc: true,props, emit, dialog, currentPageIndex, currentPage, totalPages, isDesktop, LightboxView, BaseButton, Icon }
}

})